import React, { useState } from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer';

const faqData = [
    {
        category: 'General',
        icon: 'fa-circle-question',
        questions: [
            { q: 'What is My Property Guru?', a: 'My Property Guru is a premier real estate platform that connects home buyers with trusted builders and premium projects across Gujarat. We provide verified listings, virtual tours, and expert guidance to help you find your dream property.' },
            { q: 'Is it free to browse properties on My Property Guru?', a: 'Yes, browsing properties, comparing projects, and contacting builders on My Property Guru is completely free for home buyers. There are no hidden charges for exploring our listings.' },
            { q: 'How do I contact a builder or developer?', a: 'You can contact builders directly from any project page by clicking the "Schedule A Tour" or "Enquire Now" button. You can also call or email them using the contact details provided on their developer profile page.' },
        ]
    },
    {
        category: 'Buying Property',
        icon: 'fa-house',
        questions: [
            { q: 'How do I search for properties?', a: 'Use our search bar on the homepage to search by city, locality, or project name. You can also filter results by property type, budget range, BHK configuration, and project status.' },
            { q: 'What documents are needed to buy a property?', a: 'Typically, you need identity proof (Aadhaar/PAN), address proof, income proof (salary slips or ITR), bank statements, passport-size photographs, and property documents like allotment letter and agreement of sale.' },
            { q: 'Does My Property Guru help with home loans?', a: 'While we don\'t directly provide home loans, we connect you with banking partners who offer competitive rates. Many of our listed projects are pre-approved by leading banks for easy loan processing.' },
            { q: 'How can I verify if a project is RERA registered?', a: 'All projects listed on My Property Guru display their RERA registration number. You can verify on the official RERA Gujarat website by entering the project RERA number.' },
        ]
    },
    {
        category: 'For Builders',
        icon: 'fa-building',
        questions: [
            { q: 'How can I list my project on My Property Guru?', a: 'Builders can register as a developer on our platform. Contact our team at info@mypropertyguru.in or call +91 95370 02666 to get started with a free listing.' },
            { q: 'What are the benefits of listing on My Property Guru?', a: 'You get access to a large pool of verified home buyers, premium showcasing with photos and virtual tours, lead management tools, and analytics to track your project\'s performance.' },
            { q: 'Is there a fee for listing projects?', a: 'We offer both free and premium listing plans. Free listings include basic project information, while premium plans offer featured placement, priority support, and advanced analytics.' },
        ]
    },
    {
        category: 'Account & Support',
        icon: 'fa-headset',
        questions: [
            { q: 'How do I create an account?', a: 'Click "Sign In" in the top right corner and then select "Create Account". Fill in your details including name, email, phone number, and password.' },
            { q: 'I forgot my password. How can I reset it?', a: 'Click on "Sign In" and select "Forgot Password". Enter your registered email and we\'ll send you a password reset link.' },
            { q: 'How can I contact customer support?', a: 'Reach our support team by calling +91 95370 02666, emailing info@mypropertyguru.in, or visiting our Contact page. Available Monday to Saturday, 9 AM to 7 PM.' },
        ]
    }
];

export default function Faq() {
    const [activeIndex, setActiveIndex] = useState<string | null>('0-0');
    const [activeCategory, setActiveCategory] = useState(0);

    return (
        <>
            <Navbar transparent={false} />
            <section style={{
                background: 'linear-gradient(135deg, #05144b 0%, #0a2a8d 50%, #1e40af 100%)',
                padding: '80px 0 60px', position: 'relative', overflow: 'hidden'
            }}>
                <div style={{ position: 'absolute', top: '-60px', right: '-60px', width: '250px', height: '250px', borderRadius: '50%', background: 'rgba(255,255,255,0.03)' }}></div>
                <div className="container position-relative" style={{ zIndex: 2 }}>
                    <div className="d-flex align-items-center gap-2 mb-3">
                        <div style={{ width: '40px', height: '3px', background: '#f1ae24', borderRadius: '2px' }}></div>
                        <span style={{ color: '#f1ae24', fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '2px' }}>Help Center</span>
                    </div>
                    <h1 className="text-white fw-bold mb-3" style={{ fontSize: '2.5rem' }}>Frequently Asked <span style={{ color: '#f1ae24' }}>Questions</span></h1>
                    <p className="mb-0" style={{ color: 'rgba(255,255,255,0.7)', maxWidth: '600px', lineHeight: 1.7 }}>
                        Find answers to common questions about buying property, listing projects, and using My Property Guru.
                    </p>
                </div>
            </section>

            <section style={{ background: '#f8f9fa', padding: '60px 0 80px' }}>
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-3">
                            <div className="bg-white rounded-4 shadow-sm p-3 sticky-top" style={{ top: '100px', zIndex: 1 }}>
                                <h6 className="fw-bold text-muted mb-3 px-2" style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Categories</h6>
                                {faqData.map((cat, i) => (
                                    <button key={i} onClick={() => { setActiveCategory(i); setActiveIndex(null); }}
                                        className="d-flex align-items-center gap-2 w-100 border-0 rounded-3 mb-2 px-3 py-3"
                                        style={{
                                            background: activeCategory === i ? '#05144b' : 'transparent',
                                            color: activeCategory === i ? '#fff' : '#333',
                                            fontWeight: 600, fontSize: '0.88rem', cursor: 'pointer', transition: 'all 0.3s ease'
                                        }}>
                                        <i className={`fa-solid ${cat.icon}`} style={{ width: '20px', color: activeCategory === i ? '#f1ae24' : '#999' }}></i>
                                        {cat.category}
                                        <span className="ms-auto badge rounded-pill" style={{
                                            background: activeCategory === i ? 'rgba(255,255,255,0.2)' : '#f0f0f0',
                                            color: activeCategory === i ? '#fff' : '#666', fontSize: '0.7rem'
                                        }}>{cat.questions.length}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="d-flex align-items-center gap-3 mb-4">
                                <div style={{ width: '45px', height: '45px', borderRadius: '12px', background: '#05144b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i className={`fa-solid ${faqData[activeCategory].icon} text-white`}></i>
                                </div>
                                <div>
                                    <h4 className="fw-bold mb-0">{faqData[activeCategory].category}</h4>
                                    <p className="text-muted small mb-0">{faqData[activeCategory].questions.length} questions</p>
                                </div>
                            </div>
                            {faqData[activeCategory].questions.map((faq, j) => {
                                const key = `${activeCategory}-${j}`;
                                const isOpen = activeIndex === key;
                                return (
                                    <div key={key} className="bg-white rounded-4 mb-3 overflow-hidden" style={{
                                        border: isOpen ? '1px solid rgba(5,20,75,0.15)' : '1px solid #eee',
                                        boxShadow: isOpen ? '0 8px 25px rgba(5,20,75,0.08)' : 'none', transition: 'all 0.3s ease'
                                    }}>
                                        <button onClick={() => setActiveIndex(isOpen ? null : key)}
                                            className="d-flex align-items-center justify-content-between w-100 border-0 bg-transparent p-4"
                                            style={{ cursor: 'pointer', textAlign: 'left' }}>
                                            <span className="fw-bold" style={{ color: isOpen ? '#05144b' : '#333', fontSize: '0.95rem' }}>{faq.q}</span>
                                            <div style={{
                                                width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0,
                                                background: isOpen ? '#05144b' : '#f0f0f0', color: isOpen ? '#fff' : '#666',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                transition: 'all 0.3s ease', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                                            }}>
                                                <i className="fa-solid fa-chevron-down" style={{ fontSize: '12px' }}></i>
                                            </div>
                                        </button>
                                        <div style={{
                                            maxHeight: isOpen ? '300px' : '0', overflow: 'hidden',
                                            transition: 'max-height 0.4s ease', padding: isOpen ? '0 24px 20px' : '0 24px'
                                        }}>
                                            <p style={{ color: '#666', lineHeight: 1.8, fontSize: '0.9rem', margin: 0 }}>{faq.a}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
